import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment.development';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ErrorHandleService } from './error-handle.service';
import { IncompleteDataDetailResponse, IncompleteDataResponse } from '../models/incomplete-data';
import { catchError, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IncompleteDataService {

  private apiUrl = `${environment.APIDEV}`;

  constructor(
    private http: HttpClient,
    private errorHandle: ErrorHandleService
  ) { }

  getIncompleteData(
    startDate?: string,
    endDate?: string
  ): Observable<IncompleteDataResponse> {
    let params = new HttpParams()

    if (startDate) {
      params = params.set('startDate', startDate);
    }
    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<IncompleteDataResponse>(`${this.apiUrl}overview/incomplete_data`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  getIncompleteDataDetail(
    startDate?: string,
    endDate?: string,
    businessLineId?: any
  ): Observable<IncompleteDataDetailResponse> {  // Gunakan interface yang sesuai
    let params = new HttpParams()

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    if (businessLineId) {
      params = params.set('businessLineId', businessLineId);
    }

    return this.http.get<IncompleteDataDetailResponse>(`${this.apiUrl}overview/incomplete_data_detail`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

}
